import { render, staticRenderFns } from "./PaymentRegulation.vue?vue&type=template&id=22cd2082&scoped=true"
import script from "./PaymentRegulation.vue?vue&type=script&lang=js"
export * from "./PaymentRegulation.vue?vue&type=script&lang=js"
import style0 from "./PaymentRegulation.vue?vue&type=style&index=0&id=22cd2082&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd2082",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22cd2082')) {
      api.createRecord('22cd2082', component.options)
    } else {
      api.reload('22cd2082', component.options)
    }
    module.hot.accept("./PaymentRegulation.vue?vue&type=template&id=22cd2082&scoped=true", function () {
      api.rerender('22cd2082', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment-regulation/PaymentRegulation.vue"
export default component.exports